var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCarrinho = function SvgCarrinho(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8.2008045 8.2006881",
    height: 30.995001,
    width: 30.995001,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m.26830072.33907745 1.27736758.228462 1.816701 4.59780595 4.2578922-.371252.3122457-2.4988069-5.7515468-.171347",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "green",
      strokeWidth: 0.536578,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "green",
      strokeWidth: 0.18520932,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m2.5620313 3.2280875 5.2513264.0074m-4.9207687.8750009 4.8027971.0074m-4.3763677 1.056043.0074-3.0433349m.9259439 3.0035459.0074-2.9547089m.9415761 2.8322719.0074-2.8261879m.9102911 2.7443319.0074-2.6767069m.941576 2.5975209.0074-2.6088259"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "green",
      strokeWidth: 0.536578,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m7.6719103 6.6898184-4.9925559-.08627c-.7480817-.46134.1368961-.760386.7388086-1.423487v0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "green",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.94323,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    cx: 2.9270067,
    cy: 7.4704857,
    rx: 0.65544581,
    ry: 0.65941381
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.94323,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    cx: 2.9270067,
    cy: 7.4704857,
    rx: 0.27388847,
    ry: 0.27554655
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "green",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.94324,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    cx: 7.1924739,
    cy: 7.5091553,
    rx: 0.59293574,
    ry: 0.59652525
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.94326,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    cx: 7.1924739,
    cy: 7.5091553,
    rx: 0.24776763,
    ry: 0.24926758
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarrinho, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/carrinho.f3f3fa95.svg";
export { ForwardRef as ReactComponent };